module.exports = __webpack_public_path__ + "04_long_grey.3f8fc533.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_long_grey.png
// module id = +/e9
// module chunks = 0